module.exports = __webpack_public_path__ + "img/porch-swing.de0a7eb5.jpg";